import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';
import UI from '../ui';
import Utils from '../utils';
import Auth from './Auth.component';
import ModalModule from '../modal';

const {
	Session,
	Navigation,
	Util: { getFraudNumber, removeCookie, getCookie, setCookie, getQueryParamByName },
	Logger,
	StyleLoader,
} = Utils;
const { WrappedInputTextWithLabel, WrappedCheckbox, WrappedButton, WrappedButtonType, Link } = UI;
const { ModalButtonActionType } = ModalModule;

export class SignInForm extends Component {
	constructor(props) {
		super(props);

		const username = getQueryParamByName('username') || getCookie('print_username') || '';
		const password = getQueryParamByName('tempPw') || '';

		this.state = {
			username,
			password,
			rememberUsername: !!username,
			validations: {
				username: username ? 1 : 0,
				password: 0,
			},
			errorMessages: {
				username: username ? '' : 'This field is required',
				password: 'This field is required',
			},
			isAuthenticating: false,
			status: null,
		};
	}

	componentDidMount() {
		const { username, password } = this.state;

		if (username && password) {
			this.setState({ isAuthenticating: true });
		}
	}

	// stop rendering Auth, reflect Auth's status response, and render any error messages
	authCallback = ({ status, errorDescription = '' }) => {
		const { signInCallback } = this.props;

		this.setState(prevState => ({
			isAuthenticating: false,
			status,
			validations: {
				...prevState.validations,
				username: errorDescription ? -1 : prevState.validations.username,
			},
			errorMessages: {
				...prevState.errorMessages,
				username: errorDescription,
			},
		}));

		signInCallback({ status });
	};

	renderAuthenticateUser = () => {
		const { resetPasswordSuccessCallback, history } = this.props;
		const { username, password } = this.state;
		const loginSource = Session.getSettings().isInWebStore ? 'WebStoreSignIn' : 'SigninPage';

		return (
			<Auth
				userName={username}
				password={password}
				loginSource={loginSource}
				callback={this.authCallback}
				history={history}
			/>
		);
	};

	onClickVisitWebsite = () => {
		const cookieName = 'existingcust';

		if (getCookie(cookieName) !== undefined) {
			removeCookie(cookieName, '/', Session.getBrand().domain);
		}

		Logger.logToServer({
			category: 'ui_interaction',
			action: 'click',
			ui_element: 'visit_website_link',
		});

		Navigation.navigateTo('homePage', { navType: 'newTab' });
	};

	onClickRegistration = () => {
		const cookieName = 'existingcust';

		if (getCookie(cookieName) !== undefined) {
			removeCookie(cookieName);
		}

		Logger.logToServer({
			category: 'ui_interaction',
			action: 'click',
			ui_element: 'sign_up_link',
		});

		Navigation.navigateTo('register');
	};

	onFieldChange = e => {
		const { value, name } = e.target;

		this.setState({
			[name]: value,
		});
	};

	onFieldBlur = e => {
		const { status } = this.state;
		const {
			target: { name },
		} = e;
		// eslint-disable-next-line react/destructuring-assignment
		const fieldValue = this.state[name];

		// this block will validate the username field in cases where the Auth status is false
		// and the error message from the server is displayed under username
		if (status === false) {
			this.setState(prevState => ({
				validations: {
					...prevState.validations,
					username: prevState.username !== '' ? 1 : -1,
				},
				errorMessages: {
					...prevState.errorMessages,
					username: prevState.username !== '' ? '' : 'This field is required',
				},
			}));
		}

		this.setState(prevState => ({
			validations: {
				...prevState.validations,
				[name]: fieldValue !== '' ? 1 : -1,
			},
			errorMessages: {
				...prevState.errorMessages,
				[name]: fieldValue !== '' ? '' : 'This field is required',
			},
		}));
	};

	onRememberUsernameToggle = () => {
		this.setState(prevState => ({
			rememberUsername: !prevState.rememberUsername,
		}));
	};

	onSignIn = e => {
		e.preventDefault();

		const { validations, errorMessages, rememberUsername, username } = this.state;
		const newValidations = { ...validations };
		const newErrorMessages = { ...errorMessages };
		const { domain } = Session.getBrand();

		Logger.saveActionData('Sign In Button Clicked');

		let validated = false;

		Object.keys(newValidations).forEach(key => {
			if (newValidations[key] === 0) {
				newValidations[key] = -1;
			}

			// eslint-disable-next-line react/destructuring-assignment
			if (this.state[key] !== '') {
				newValidations[key] = 1;
				newErrorMessages[key] = '';
			} else {
				newValidations[key] = -1;
				newErrorMessages[key] = 'This field is required';
			}
		});

		this.setState({
			validations: newValidations,
			errorMessages: newErrorMessages,
		});

		if (!Object.values(newValidations).includes(-1)) {
			validated = true;
		}

		if (validated) {
			Logger.logToServer({
				category: 'ui_interaction',
				action: 'click',
				ui_element: 'sign_in_button',
			});

			if (rememberUsername) {
				setCookie('print_username', username, 91, '/', domain);
			} else {
				removeCookie('print_username');
			}

			this.setState({
				isAuthenticating: true,
			});
		}
	};

	launchForgotUsernameModal = () => {
		const { history } = this.props;

		Logger.logToServer({
			category: 'ui_interaction',
			action: 'click',
			ui_element: 'forgot_username_link',
		});

		history.push('/recoverusername'); // Navigate to the recoverUsername view
	};

	launchForgotPasswordModal = () => {
		const { history } = this.props;
		const { username } = this.state;

		Logger.logToServer({
			category: 'ui_interaction',
			action: 'click',
			ui_element: 'forgot_password_link',
		});

		history.push(`/recoverpassword?username=${username}`);
	};

	renderSignUpLink = mobileClassName => (
		<>
			<div className={`signup-row ${mobileClassName}`}>
				<Link
					onClick={this.onClickVisitWebsite}
					className={`visit-website-link ${mobileClassName}`}
					dataqa="signin-visit-website-link"
				>
					Visit Website
				</Link>
			</div>
			{!isMobile && (
				<div className={`signup-row ${mobileClassName}`}>
					<Link
						onClick={this.onClickRegistration}
						className="signup-link"
						dataqa="signin-signup-link"
					>
						Sign Up
					</Link>
				</div>
			)}
		</>
	);

	renderForgotUserName = mobileClassName => (
		<Link
			className={`forgot-link ${mobileClassName}`}
			onClick={this.launchForgotUsernameModal}
			dataqa="signin-forgot-username-link"
		>
			Forgot Username?
		</Link>
	);

	renderForgotPassword = mobileClassName => (
		<Link
			className={`forgot-link ${mobileClassName}`}
			onClick={this.launchForgotPasswordModal}
			dataqa="signin-forgot-password-link"
		>
			Forgot Password?
		</Link>
	);

	renderVerifySupport = fraudNumber => (
		<div className="verify-support">
			Having trouble logging in? You can call our support team at {fraudNumber} between 6 a.m.
			and 6 p.m. Pacific Time.'
		</div>
	);

	bottomLinks = (mobileClassName, brandName) => (
		<>
			<div className={`row-container centered ${mobileClassName}`}>
				<p className="reset-links">
					Trouble signing in?&nbsp;{isMobile && <br />}
					<Link
						className={`forgot-link ${mobileClassName}`}
						onClick={this.launchForgotPasswordModal}
						dataqa="signin-reset-password-link"
					>
						Reset Password
					</Link>
					&nbsp;or&nbsp;
					<Link
						className={`forgot-link ${mobileClassName}`}
						onClick={this.launchForgotUsernameModal}
						dataqa="signin-find-username-link"
					>
						Find Username
					</Link>
				</p>
			</div>
			<hr />
			<div
				className={`row-container stamps-signin-form-font-size centered ${mobileClassName}`}
			>
				<p>{`Don't have a ${brandName} account yet?`}</p>
			</div>
			<div className={`row-container centered getting-started-row ${mobileClassName}`}>
				<WrappedButton
					className={`${mobileClassName} signin-secondary-button`}
					buttonType={WrappedButtonType.Secondary}
					onClick={this.onClickRegistration}
					type="submit"
					label="Get Started"
					dataqa="getstarted-button"
				/>
			</div>
		</>
	);

	render() {
		const { responsiveCls, isInWebStore } = this.props;
		const {
			username,
			password,
			rememberUsername,
			validations,
			errorMessages,
			isAuthenticating,
		} = this.state;
		const { Page } = Session.getSettings();
		const brand = Session.getBrand();
		const fraudNumber = getFraudNumber(brand);

		return (
			<div
				className={`common-authentication authentication-signin-form ${
					isInWebStore ? 'in-web-store' : ''
				}`}
			>
				{isAuthenticating && this.renderAuthenticateUser()}

				<form className={`form ${responsiveCls}`} onSubmit={this.onSignIn}>
					{!isInWebStore && (
						<>
							<div className="brand-logo" />
							<div className={`signin-primary-header ${responsiveCls}`}>
								Welcome Back!
							</div>
						</>
					)}

					<div className="row-container">
						<WrappedInputTextWithLabel
							className={responsiveCls}
							label="Username"
							showErrorBelow
							isInputInvalid={validations.username === -1}
							errorMessage={errorMessages.username}
							uiElementConfig={{
								type: 'text',
								onChange: this.onFieldChange,
								onBlur: this.onFieldBlur,
								value: username,
								placeholder: 'USERNAME',
								dataqa: 'signin-username',
								name: 'username',
								autoFocus: username.length === 0,
								tabIndex: 1,
							}}
						/>
					</div>
					<div className="row-container">
						<WrappedInputTextWithLabel
							className={responsiveCls}
							label="Password"
							showErrorBelow
							isInputInvalid={validations.password === -1}
							errorMessage={errorMessages.password}
							uiElementConfig={{
								type: 'password',
								onChange: this.onFieldChange,
								onBlur: this.onFieldBlur,
								value: password,
								placeholder: 'PASSWORD',
								dataqa: 'signin-password',
								name: 'password',
								autoFocus: username.length > 0,
								tabIndex: 2,
								showPasswordTabIndex: 3,
							}}
						/>
					</div>

					<div className="row-container">
						<WrappedCheckbox
							className="remember-username"
							onChange={this.onRememberUsernameToggle}
							value={rememberUsername}
							name="rememberUsername"
							checked={rememberUsername}
							inputId="rememberUsername"
							htmlFor="rememberUsername"
							dataqa="signin-rememberusername"
						>
							<span className={`remember-username-label ${responsiveCls}`}>
								Remember my username
							</span>
						</WrappedCheckbox>
					</div>

					<div className="row-container centered">
						<WrappedButton
							className={`${responsiveCls}`}
							buttonType={WrappedButtonType.Primary}
							type="submit"
							label="Log In"
							disabled={isAuthenticating}
							dataqa="signin-button"
						/>
					</div>

					{!isInWebStore && this.bottomLinks(responsiveCls, brand.brandName)}

					{!isInWebStore && (
						<div className="row-container centered">
							{Page !== 'verify' && (
								<>
									<Link
										className="visit-website"
										onClick={this.onClickVisitWebsite}
										dataqa="signin-visit-website-link"
									>
										Visit Website
									</Link>
								</>
							)}
							{Page === 'verify' && this.renderVerifySupport(fraudNumber)}
						</div>
					)}
					{!isInWebStore && Page === 'verify' && (
						<div className="row-container centered">
							{this.renderVerifySupport(fraudNumber)}
						</div>
					)}
				</form>
			</div>
		);
	}
}
